import UtilitiesService from './util';
import Authorization from "./authorization/authorizationService";
import ProductService from "./fake/productService";
import TimesheetService from "./timesheet/timesheetService";
import SampleService from "./sample/sampleService";
import AllocationService from "./allocation/allocation";
import UserAllocationService from "./allocation/user_allocation";
import AttendanceService from './attendance/attendanceService';
import ApiDocService from './documentation/api-docs';
import ExpenseService from './expense/expenseService';
import trainingService from './training/trainingService';
import HelpDeskService from './helpdesk/helpDeskService';
import SupportService from './support/supportService';

const sampleService = new SampleService();
const AuthService = new Authorization();
const allocationService = new AllocationService();
const userAllocationService = new UserAllocationService();
const apiDocService = new ApiDocService();
// Fake Services
const products = new ProductService();
// Timesheet Services
const timesheetApi = new TimesheetService();
const trainingApi= new trainingService();
let Util = new UtilitiesService();

const attendanceApi = new AttendanceService();
const expenseApi = new ExpenseService();
const helpDeskApi = new HelpDeskService();
const supportApi = new SupportService();

const fakeData = {
    products
}

export {
    Util, AuthService, fakeData, timesheetApi, sampleService, allocationService, userAllocationService, attendanceApi, apiDocService, expenseApi, trainingApi, helpDeskApi, supportApi
}